export const PAGE_ROUTES = {
  HOME: "/",
};

//Sections of the (single page) site - the ids are also the #hash links
export const SECTIONS = {
  SERVICES: "services",
  ABOUT: "about",
  CONTACT: "contact",
};

export const NAV_LINKS = [
  { label: "Services", section: SECTIONS.SERVICES },
  { label: "About", section: SECTIONS.ABOUT },
];

export const CONTACT_DETAILS = {
  EMAIL: "corlea@cgeyer.co.za",
  PHONE: "+27 82 3000 389",
  PHONE_LINK: "tel:+27823000389",
};

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  CONTACT_SEND: "ls_1",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  SUCCESS: 1,
  ERROR: 2,
};
